import React from 'react';
import { Button } from 'common.ui';
import { AuthService } from 'auth/AuthService';
import RoutePaths from 'RoutePaths';
import { useTranslation } from 'react-i18next';
import Page from '../../components/page/Page';

function ChangeSigninEmail() {
  const { t } = useTranslation('pages', { keyPrefix: 'changeSigninEmail.changeSigninEmail' });

  // Samme mønster som passordbytte: utloggingen skjer på et klikk fra en rolig side, ikke midt i
  // oppstarten av appen. Da er det ingen andre navigasjoner som kan overskrive utloggingen.
  const onButtonClick = async () => {
    await AuthService.signOut(RoutePaths.postLogout);
  };

  return (
    <Page header={t('title')} title={t('title')}>
      <p>
        <br />
        {t('message.completed')}
        <br />
        <br />
        <Button type='button' onClick={onButtonClick} text={t('btnText.continue')} styleType='light' />
      </p>
    </Page>
  );
}

export default ChangeSigninEmail;
